import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import UsersTableRow from './UsersTableRow';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';
import ApproverReplacementModal from './ApproverReplacementModal';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import { getRequest } from '../../../lib/apiUtils';
import { PermissionTypes } from '../../../lib/systemVariables';

export default class UsersTable extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = this.initialState;

        this.getTableRow = this.getTableRow.bind(this);
    }

    initialState = {
        showModals: {
            confirmationModal: false,
            approverReplacementModal: false
        },
        selectedRecord: {},
        loadingUserPermissions: false
    };

    getTableRow(user) {
        return <UsersTableRow key={user.userId} user={user}
            viewUserDetails={this.props.viewUserDetails} toggleActive={this.toggleUserActive.bind(this)} />;
    }

    toggleUserActive(activate, user) {
        this.setState({
            selectedRecord: user
        }, async () => {
            let deactivatingApprover = false;
            if (!activate) {
                this.setState({ loadingUserPermissions: true });
                const permissions = await getRequest(`/users/${user.userId}/permissions`, null, {});
                deactivatingApprover = (permissions.data.indexOf(PermissionTypes.ApplicationsApproveFull) >= 0 || permissions.data.indexOf(PermissionTypes.ApplicationsApproveLimited) >= 0);
                this.setState({ loadingUserPermissions: false });
            }
            this.toggleModal(deactivatingApprover ? "approverReplacementModal" : "confirmationModal")
        }); 
    }

    render() {
        return (
            <div>
                {this.state.loadingUserPermissions && <div className="spinner-absolute user-settings-spinner"><LoadingSpinner height="32" /></div>}

                <PaginatedTable
                    name="users"
                    page={this.props.page}
                    totalCount={this.props.data.totalCount}
                    resultsView={this.props.resultsView}
                    sort={this.props.sort}
                    loading={this.props.loading}
                    success={this.props.success}
                    renderRow={this.getTableRow}
                    columns={[
                        { id: 'name', title: 'Name', sortable: true },
                        { id: 'department', title: 'Department', sortable: true },
                        { id: 'email', title: 'Email', sortable: true },
                        { id: 'phone', title: 'Phone', sortable: true },
                        { id: 'role', title: 'Role', sortable: true },
                        { id: 'active', title: 'Active', sortable: false }]}
                    records={this.props.data.records || []}
                    sortData={this.props.updateTable}
                    changeDataView={this.props.updateTable}
                    loadData={this.props.getUsers} />

                <ApproverReplacementModal
                    show={this.state.showModals.approverReplacementModal}
                    close={approverId => {
                        if (approverId) {
                            this.setState({
                                selectedRecord: { ...this.state.selectedRecord, replacementApproverId: approverId }
                            }, this.toggleModals.bind(this, ["approverReplacementModal", "confirmationModal"]));
                        } else {
                            this.setState({ selectedRecord: this.initialState.selectedRecord });
                            this.toggleModal("approverReplacementModal");
                        }
                    }}
                    user={this.state.selectedRecord}
                    approvers={this.props.approvers}
                />

                <ConfirmationModal
                    show={this.state.showModals.confirmationModal}
                    message={this.state.selectedRecord.userId
                        ? `Are you sure you want to ${this.state.selectedRecord.active ? "deactivate" : "activate"} ${this.state.selectedRecord.name}?` : ''}
                    close={() => {
                        this.setState({ selectedRecord: this.initialState.selectedRecord });
                        this.toggleModal("confirmationModal");
                    }}
                    confirm={this.props.toggleUserActive.bind(this, this.state.selectedRecord.userId, !this.state.selectedRecord.active, this.state.selectedRecord.replacementApproverId)}
                    loading={this.props.updatingActive.loading}
                    success={this.props.updatingActive.success}
                    errorMessage={this.props.updatingActive.message}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/settingComponents/userSettings/UsersTable.jsx